import React, { useRef } from 'react';
import styled from 'styled-components';
import AnswerAttachments from '@Pages/ClassRooms/Pages/SingleClassroom/Components/Submissions/Components/AnswerAttachments';
import { StudentAnswerHtml } from '@RichTextEditor';
import { FeedbacktWrapper } from '../GapAnswer/GapAnswer';
import { QuestionContentWrapper, Text } from '../OrderingAnswer/OrderingAnswer';
import { IEssayAnswer, Test } from '../TestSummary.types';

type EssayProps = {
	question: IEssayAnswer;
	test: Test | undefined;
	status: string | undefined;
};

const EssayAnswer: React.VoidFunctionComponent<EssayProps> = ({ question }) => {
	const gapRef = useRef<HTMLDivElement>(null);
	const options = question.answer?.content?.options;

	return (
		<QuestionContentWrapper>
			{question.content && (
				<StyledContainer
					ref={gapRef}
					dangerouslySetInnerHTML={{ __html: question?.content as string }}
				/>
			)}
			{/* An attachment answer is a JSON array of file URLs — rendering it as
			    text showed graders a raw JSON string. Ternary on purpose: legacy
			    rows without a `type` still render as text. */}
			{options?.type === 'attachment' ? (
				<AnswerAttachments answer={String(options.answer ?? '')} />
			) : (
				<Answer as="div">
					<StudentAnswerHtml html={options?.answer as string} />
				</Answer>
			)}
			{question.feedback !== null && (
				<>
					<FeebackText>Feedback</FeebackText>
					<FeedbacktWrapper
						dangerouslySetInnerHTML={{ __html: question?.feedback as string }}
					/>
				</>
			)}
		</QuestionContentWrapper>
	);
};

const Answer = styled.p`
	font-size: 0.75rem;
	font-weight: 500;
	color: #2f2e41;
	line-height: 1.9;
	letter-spacing: 0.09px;
	@media screen and (min-width: 769px) {
		font-size: 1.125rem;
		line-height: 1.7;
		letter-spacing: 0.14px;
	}
`;

const FeebackText = styled(Text)`
	margin: 0.563rem;
	@media screen and (min-width: 769px) {
		margin: 2.063rem;
	}
`;

const StyledContainer = styled.div`
	font-size: 0.75rem;
	font-weight: 600;
	color: #2f2e41;
	line-height: 1.9;
	letter-spacing: 0.09px;
	@media screen and (min-width: 769px) {
		font-size: 1.125rem;
		line-height: 1.7;
		letter-spacing: 0.14px;
	}
`;
export default EssayAnswer;
